<template>
  <div class="rp-page kassa-closing">
    <div class="rp-container">
      <div class="print-head">
        <div>
          <div class="print-brand">PROFCAR</div>
          <h1>Kassa yopish hisoboti</h1>
        </div>
        <div class="print-meta">
          <div><span>Davr:</span> {{ date1 }} - {{ date2 }}</div>
          <div><span>Sklad:</span> {{ selectedSkladName }}</div>
          <div><span>Pechat:</span> {{ printDate }}</div>
        </div>
      </div>

      <div class="rp-header">
        <div class="d-flex align-items-center">
          <button class="rp-back" @click="$router.push('/xisobot/main')"><b-icon icon="chevron-left"></b-icon></button>
          <h2 class="rp-title"><b-icon icon="clipboard-check" class="mr-2"></b-icon>Kassa yopish</h2>
        </div>
        <div class="rp-actions">
          <button class="rp-btn rp-btn-secondary" @click="doPrint"><b-icon icon="printer"></b-icon> Pechat</button>
          <button class="rp-btn rp-btn-primary" @click="fetch" :disabled="loading">
            <b-icon icon="arrow-repeat"></b-icon> Yangilash
          </button>
        </div>
      </div>

      <div class="rp-filters">
        <div class="rp-filter"><label>Boshlanish</label><input type="date" v-model="date1"></div>
        <div class="rp-filter"><label>Tugash</label><input type="date" v-model="date2"></div>
        <div class="rp-filter rp-filter-grow">
          <label>Sklad</label>
          <v-select :options="skladList" v-model="sklad_id" :reduce="s => s.id" label="name" placeholder="Barchasi" />
        </div>
        <button class="rp-btn rp-btn-primary" @click="fetch" :disabled="loading">
          <b-icon icon="arrow-repeat"></b-icon> Hisoblash
        </button>
      </div>

      <div v-if="error" class="alert alert-danger" role="alert">{{ error }}</div>
      <div class="rp-summary rp-summary-6">
        <div class="rp-card rp-c-1"><div class="rp-card-label">Kassa kirim</div><div class="rp-card-value rp-green">{{ fmt(totals.kassa_kirim) }}</div><div v-if="hasDollar" class="rp-card-dollar">$ {{ fmt(totals.kassa_kirim_dollar) }}</div></div>
        <div class="rp-card rp-c-3"><div class="rp-card-label">Kassa chiqim</div><div class="rp-card-value rp-red">{{ fmt(totals.kassa_chiqim) }}</div><div v-if="hasDollar" class="rp-card-dollar">$ {{ fmt(totals.kassa_chiqim_dollar) }}</div></div>
        <div class="rp-card rp-c-2"><div class="rp-card-label">Kassa netto</div><div class="rp-card-value">{{ fmt(totals.kassa_net) }}</div><div v-if="hasDollar" class="rp-card-dollar">$ {{ fmt(totals.kassa_net_dollar) }}</div></div>
        <div class="rp-card rp-c-4"><div class="rp-card-label">Foiz ustalar</div><div class="rp-card-value">{{ fmt(totals.percent_master_summa) }}</div></div>
        <div class="rp-card rp-c-5"><div class="rp-card-label">Fiksa ustalar</div><div class="rp-card-value">{{ fmt(totals.fixed_master_summa) }}</div></div>
        <div class="rp-card rp-c-6"><div class="rp-card-label">Kassadan qoladi</div><div class="rp-card-value">{{ fmt(totals.after_master) }}</div></div>
      </div>

      <div class="rp-2col">
        <div class="rp-section">
          <h3 class="rp-block-title"><b-icon icon="wallet2"></b-icon> Kassa to'lov turlari</h3>
          <div class="rp-table-wrap">
            <table class="rp-table">
              <thead><tr><th>To'lov turi</th><th class="t-right">Kirim</th><th class="t-right">Chiqim</th><th class="t-right">Netto</th></tr></thead>
              <tbody>
                <tr v-for="r in cashByPayType" :key="r.pay_type_id">
                  <td class="rp-strong">{{ r.pay_type_name }}</td>
                  <td class="t-right rp-green">{{ cur(r) }}{{ fmt(r.kirim) }}</td>
                  <td class="t-right rp-red">{{ cur(r) }}{{ fmt(r.chiqim) }}</td>
                  <td class="t-right rp-strong">{{ cur(r) }}{{ fmt(r.net) }}</td>
                </tr>
                <tr v-if="cashByPayType.length === 0"><td colspan="4" class="rp-empty">Kassa harakati yo'q</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="rp-section">
          <h3 class="rp-block-title"><b-icon icon="calculator"></b-icon> Kun yakuni</h3>
          <div class="closing-ledger">
            <div><span>Xizmat savdolari</span><b>{{ totals.service_sales || 0 }} ta</b></div>
            <div><span>Xizmat daromadi</span><b>{{ fmt(totals.service_revenue) }}</b></div>
            <div><span>Mahsulot summasi</span><b>{{ fmt(totals.product_summa) }}</b></div>
            <div><span>Ustalarga jami</span><b>{{ fmt(totals.master_total) }}</b></div>
            <div class="ledger-total"><span>Kirim - ustalar</span><b>{{ fmt(totals.after_master) }}</b></div>
          </div>
        </div>
      </div>

      <div class="rp-section closing-movements">
        <h3 class="rp-block-title"><b-icon icon="journal-text"></b-icon> Kassa chiqimlari va order kirimlari</h3>
        <div class="rp-table-wrap">
          <table class="rp-table">
            <thead>
              <tr>
                <th>№</th><th>Sana</th><th>Turi</th><th>Hujjat</th><th>Kimga</th><th>Asos</th><th>Izoh (nima uchun)</th><th>Sklad</th>
                <th>To'lov turi</th><th class="t-right">Summa</th><th>Kassir</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in cashMovements" :key="r.id">
                <td><span class="rp-num">{{ r.number || r.doc_id }}</span></td>
                <td>{{ fmtDate(r.datetime) }}</td>
                <td>
                  <span class="rp-badge" :class="isKirim(r) ? 'rp-badge-green' : 'rp-badge-red'">{{ isKirim(r) ? 'Kirim' : 'Chiqim' }}</span>
                </td>
                <td>{{ r.document_name || 'Kassa orderi' }}</td>
                <td class="rp-strong">{{ r.recipient_name || '-' }}</td>
                <td class="rp-strong">{{ r.reason }}</td>
                <td>{{ r.comment || '-' }}</td>
                <td>{{ r.sklad_name || '-' }}</td>
                <td>{{ r.pay_type_name }}</td>
                <td class="t-right rp-strong" :class="isKirim(r) ? 'rp-green' : 'rp-red'">{{ cur(r) }}{{ fmt(r.summa) }}</td>
                <td>{{ r.user_name || '-' }}</td>
              </tr>
              <tr v-if="loading"><td colspan="11" class="rp-empty">Yuklanmoqda...</td></tr>
              <tr v-else-if="cashMovements.length === 0"><td colspan="11" class="rp-empty">Kassa harakati yo'q</td></tr>
            </tbody>
            <tfoot v-if="cashMovements.length">
              <tr><th colspan="9">Jami chiqim</th><th class="t-right rp-red">{{ fmt(totals.kassa_chiqim) }}<div v-if="hasDollar">$ {{ fmt(totals.kassa_chiqim_dollar) }}</div></th><th></th></tr>
            </tfoot>
          </table>
        </div>
      </div>

      <div class="rp-section">
        <h3 class="rp-block-title"><b-icon icon="percent"></b-icon> Foizlik ishlaydigan ustalar</h3>
        <div class="rp-table-wrap">
          <table class="rp-table">
            <thead>
              <tr>
                <th>Usta</th><th class="t-center">Ishlar</th><th class="t-right">Kassa tushumi</th>
                <th class="t-right">Xizmat daromadi</th><th class="t-center">Foiz</th><th class="t-right">Usta ulushi</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in percentStaff" :key="r.staff_id">
                <td class="rp-strong">{{ r.staff_name }}</td>
                <td class="t-center"><span class="rp-badge rp-badge-purple">{{ r.sales_count }}</span></td>
                <td class="t-right">{{ fmt(r.total_summa) }}</td>
                <td class="t-right">{{ fmt(r.service_revenue) }}</td>
                <td class="t-center"><span class="rp-badge rp-badge-info">{{ fmt(r.bonus_percent) }}%</span></td>
                <td class="t-right rp-green">{{ fmt(r.master_summa) }}</td>
              </tr>
              <tr v-if="percentStaff.length === 0"><td colspan="6" class="rp-empty">Foizlik usta bo'yicha ish yo'q</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="rp-section">
        <h3 class="rp-block-title"><b-icon icon="calendar-check"></b-icon> Kunlik fiksalik ustalar</h3>
        <div class="rp-table-wrap">
          <table class="rp-table">
            <thead>
              <tr>
                <th>Usta</th><th class="t-center">Davomat</th><th class="t-right">Oylik</th>
                <th class="t-right">Kunlik fiksa</th><th class="t-right">Davr fiksa</th><th>Kelgan kunlar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in fixedStaff" :key="r.staff_id">
                <td class="rp-strong">{{ r.staff_name }}</td>
                <td class="t-center"><span class="rp-badge rp-badge-green">{{ r.attendance_count }}</span></td>
                <td class="t-right">{{ fmt(r.monthly_salary) }}</td>
                <td class="t-right">{{ fmt(r.daily_salary) }}</td>
                <td class="t-right rp-blue">{{ fmt(r.fixed_total) }}</td>
                <td><span class="date-chip" v-for="d in r.attendance_dates" :key="r.staff_id + d">{{ d.slice(5) }}</span></td>
              </tr>
              <tr v-if="fixedStaff.length === 0"><td colspan="6" class="rp-empty">Fiksalik usta davomati yo'q</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="rp-section">
        <h3 class="rp-block-title"><b-icon icon="list-check"></b-icon> Foizli ustalar ishlari</h3>
        <div class="rp-table-wrap">
          <table class="rp-table">
            <thead>
              <tr>
                <th>#</th><th>Sana</th><th>Usta</th><th>Mijoz</th><th>Mashina</th><th>Ishlar</th>
                <th class="t-right">Tushum</th><th class="t-right">Xizmat</th><th class="t-center">Foiz</th><th class="t-right">Ulush</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="r in percentDetails" :key="r.sale_id">
                <td><span class="rp-num">{{ r.number }}</span></td>
                <td>{{ fmtDate(r.datetime) }}</td>
                <td class="rp-strong">{{ r.staff_name }}</td>
                <td>{{ r.client_name }}</td>
                <td>{{ r.car_number || '-' }}</td>
                <td>{{ r.works }}</td>
                <td class="t-right">{{ fmt(r.total_summa) }}</td>
                <td class="t-right">{{ fmt(r.service_revenue) }}</td>
                <td class="t-center">{{ fmt(r.master_percent) }}%</td>
                <td class="t-right rp-green">{{ fmt(r.master_summa) }}</td>
              </tr>
              <tr v-if="percentDetails.length === 0"><td colspan="10" class="rp-empty">Ish tafsilotlari yo'q</td></tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="print-signatures">
        <div>
          <span>Kassir</span>
          <b></b>
        </div>
        <div>
          <span>Mas'ul shaxs</span>
          <b></b>
        </div>
        <div>
          <span>Rahbar</span>
          <b></b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import './report.css';

export default {
  name: 'KassaClosing',
  data() {
    const today = this.todayStr();
    return {
      date1: today,
      date2: today,
      sklad_id: null,
      skladList: [],
      loading: false,
      error: '',
      requestId: 0,
      totals: {},
      cashByPayType: [],
      cashMovements: [],
      percentStaff: [],
      fixedStaff: [],
      percentDetails: [],
    };
  },
  mounted() {
    this.loadSklads();
    this.fetch();
  },
  computed: {
    selectedSkladName() {
      if (!this.sklad_id) return 'Barchasi';
      const s = this.skladList.find(x => Number(x.id) === Number(this.sklad_id));
      return s ? s.name : 'Barchasi';
    },
    // Dollar kassa alohida — faqat dollar harakati bo'lsa ko'rsatiladi
    hasDollar() {
      const t = this.totals;
      return !!(parseFloat(t.kassa_kirim_dollar) || parseFloat(t.kassa_chiqim_dollar));
    },
    printDate() {
      return new Date().toLocaleString('ru-RU', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      });
    },
  },
  methods: {
    todayStr() {
      const d = new Date();
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
    },
    toUnix(s, end = false) {
      return Math.floor(new Date(s + (end ? 'T23:59:59' : 'T00:00:00')).getTime() / 1000);
    },
    fmt(v) {
      return (parseFloat(v) || 0).toLocaleString('ru-RU', { maximumFractionDigits: 2 });
    },
    isKirim(r) {
      return r.type === true || Number(r.type) === 1;
    },
    cur(r) {
      return Number(r.pay_type_id) === 3 ? '$ ' : '';
    },
    fmtDate(v) {
      if (!v) return '';
      return new Date(Number(v) * 1000).toLocaleString('ru-RU', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' });
    },
    async loadSklads() {
      try { const r = await axios.get('api/v1/sklads'); this.skladList = r.data || []; }
      catch (e) { this.skladList = []; }
    },
    async fetch() {
      const requestId = ++this.requestId;
      this.loading = true;
      this.error = '';
      this.totals = {};
      this.cashByPayType = [];
      this.cashMovements = [];
      this.percentStaff = [];
      this.fixedStaff = [];
      this.percentDetails = [];
      try {
        const r = await axios.post('api/v1/report/kassa-closing/', {
          datetime1: this.toUnix(this.date1, false),
          datetime2: this.toUnix(this.date2, true),
          sklad_id: this.sklad_id || null,
        });
        if (requestId !== this.requestId) return;
        const d = r.data || {};
        this.totals = d.totals || {};
        this.cashByPayType = d.cash_by_pay_type || [];
        this.cashMovements = d.cash_movements || d.kassa_orders || [];
        this.percentStaff = d.percent_staff || [];
        this.fixedStaff = d.fixed_staff || [];
        this.percentDetails = d.percent_details || [];
      } catch (e) {
        if (requestId !== this.requestId) return;
        console.error('Kassa closing error:', e);
        this.error = "Hisobotni yuklab bo'lmadi. Qayta urinib ko'ring.";
        this.totals = {};
        this.cashByPayType = [];
        this.cashMovements = [];
        this.percentStaff = [];
        this.fixedStaff = [];
        this.percentDetails = [];
      } finally {
        if (requestId === this.requestId) this.loading = false;
      }
    },
    doPrint() {
      document.body.classList.add('kassa-closing-print');
      const cleanup = () => {
        document.body.classList.remove('kassa-closing-print');
        window.removeEventListener('afterprint', cleanup);
      };
      window.addEventListener('afterprint', cleanup);
      this.$nextTick(() => window.print());
    },
  },
  beforeDestroy() {
    document.body.classList.remove('kassa-closing-print');
  },
};
</script>

<style scoped>
.kassa-closing .rp-back { flex-shrink: 0; }
.kassa-closing .rp-card-value { overflow-wrap: anywhere; }
.closing-movements .rp-table { min-width: 1200px; }
@media (max-width: 768px) {
  .kassa-closing .rp-header { flex-wrap: wrap; gap: 12px; }
  .kassa-closing .rp-filters { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .kassa-closing .rp-filter { min-width: 0; }
  .kassa-closing .rp-filter input { width: 100%; min-width: 0; }
  .kassa-closing .rp-filter-grow { grid-column: 1 / -1; }
}
.closing-ledger {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.closing-ledger div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}
.closing-ledger span {
  color: #64748b;
  font-weight: 700;
}
.closing-ledger b {
  color: #0f172a;
  font-size: 16px;
}
.ledger-total {
  background: #ecfdf5 !important;
  border-color: #bbf7d0 !important;
}
.rp-card-dollar {
  margin-top: 2px;
  font-size: 13px;
  font-weight: 800;
  color: #10b981;
}
.date-chip {
  display: inline-block;
  margin: 2px;
  padding: 3px 7px;
  border-radius: 7px;
  background: #eef2ff;
  color: #4338ca;
  font-size: 11px;
  font-weight: 800;
}
.print-head,
.print-signatures {
  display: none;
}

@page {
  size: A4;
  margin: 10mm;
}

@media print {
  .closing-movements .rp-table { min-width: 0; table-layout: fixed; width: 100%; }
  .closing-movements .rp-table th, .closing-movements .rp-table td { white-space: normal; overflow-wrap: anywhere; }
  .rp-page {
    background: #fff !important;
    height: auto !important;
    overflow: visible !important;
    padding: 0 !important;
    color: #111827 !important;
    font-family: Arial, sans-serif !important;
  }
  .rp-container {
    max-width: none !important;
    width: 100% !important;
    margin: 0 !important;
  }
  .rp-header,
  .rp-filters,
  .rp-actions,
  .rp-back {
    display: none !important;
  }
  .print-head {
    display: flex !important;
    align-items: flex-start;
    justify-content: space-between;
    border-bottom: 2px solid #111827;
    padding-bottom: 8px;
    margin-bottom: 10px;
  }
  .print-brand {
    font-size: 13px;
    font-weight: 900;
    letter-spacing: 1px;
  }
  .print-head h1 {
    margin: 2px 0 0;
    font-size: 20px;
    font-weight: 900;
    color: #111827;
  }
  .print-meta {
    min-width: 210px;
    font-size: 11px;
    line-height: 1.6;
    text-align: right;
  }
  .print-meta span {
    color: #6b7280;
    font-weight: 700;
  }
  .rp-summary {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr) !important;
    gap: 6px !important;
    margin-bottom: 8px !important;
    break-inside: avoid;
  }
  .rp-card {
    box-shadow: none !important;
    border: 1px solid #d1d5db !important;
    border-top: 2px solid #111827 !important;
    border-radius: 0 !important;
    padding: 7px 8px !important;
    background: #fff !important;
    break-inside: avoid;
  }
  .rp-card-label {
    font-size: 8px !important;
    color: #6b7280 !important;
    margin-bottom: 3px !important;
  }
  .rp-card-value {
    font-size: 13px !important;
    color: #111827 !important;
  }
  .rp-green,
  .rp-red,
  .rp-blue,
  .rp-orange {
    color: #111827 !important;
  }
  .rp-2col {
    grid-template-columns: 1fr 1fr !important;
    gap: 8px !important;
    margin-bottom: 8px !important;
  }
  .rp-section,
  .rp-chart-wrap {
    box-shadow: none !important;
    border: 1px solid #d1d5db !important;
    border-radius: 0 !important;
    padding: 8px !important;
    margin-bottom: 8px !important;
    break-inside: avoid;
  }
  .rp-block-title {
    font-size: 12px !important;
    margin-bottom: 6px !important;
    color: #111827 !important;
  }
  .rp-table {
    font-size: 9px !important;
  }
  .rp-table th {
    position: static !important;
    background: #f3f4f6 !important;
    color: #111827 !important;
    padding: 4px 5px !important;
    font-size: 8px !important;
    border: 1px solid #d1d5db !important;
  }
  .rp-table td {
    padding: 4px 5px !important;
    border: 1px solid #e5e7eb !important;
    color: #111827 !important;
  }
  .rp-table-wrap {
    overflow: visible !important;
  }
  .rp-badge,
  .rp-num,
  .date-chip {
    background: #fff !important;
    color: #111827 !important;
    border: 1px solid #d1d5db !important;
    border-radius: 0 !important;
    padding: 1px 4px !important;
  }
  .closing-ledger {
    gap: 4px !important;
  }
  .closing-ledger div {
    border: 1px solid #d1d5db !important;
    border-radius: 0 !important;
    background: #fff !important;
    padding: 5px 6px !important;
  }
  .closing-ledger span,
  .closing-ledger b {
    color: #111827 !important;
    font-size: 10px !important;
  }
  .print-signatures {
    display: grid !important;
    grid-template-columns: repeat(3, 1fr);
    gap: 18px;
    margin-top: 18px;
    break-inside: avoid;
  }
  .print-signatures div {
    height: 42px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    gap: 8px;
  }
  .print-signatures span {
    font-size: 11px;
    font-weight: 700;
    color: #111827;
  }
  .print-signatures b {
    display: block;
    border-bottom: 1px solid #111827;
    height: 1px;
  }
}
</style>

<style>
@media print {
  body.kassa-closing-print .sidebar-custom,
  body.kassa-closing-print .sidebar-overlay,
  body.kassa-closing-print .topbar {
    display: none !important;
  }

  body.kassa-closing-print .main-panel {
    margin-left: 0 !important;
    width: 100% !important;
    float: none !important;
    transition: none !important;
  }

  body.kassa-closing-print .content-view,
  body.kassa-closing-print .wrapper {
    display: block !important;
    width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
  }

  body.kassa-closing-print {
    background: #fff !important;
    min-width: 0 !important;
  }
}
</style>
